<template lang="pug">
    apollo-query(:query="require('../graphql/JobDetail.gql')", :variables='{ locale, job_id }')
        template(slot-scope='{ result: { data }, isLoading }')
            loading(v-if='isLoading', :active='isLoading')
            page-not-found(v-else-if='!(data && data.job_detail && data.job)')
            .job(v-else, v-on:click.stop='toggleShare(false)')
                MetaTags(v-bind="data.job.meta_tags")
                layout-banner-bread-crumb(:locale="locale", :cover='data.job_detail.cover', :title='data.job_detail.title', :name='data.job.title', :prefix='data.job_detail.title', prefix_url='/jobs')
                .container.container-job(v-if='data.job')
                    .row.job__head
                        .col-12.col-md-8
                            h2 {{data.job.title}}
                            p.job__title(v-if='data.job.categories.length')
                                | {{data.job.categories[0].name}}
                        .col-12.col-md-4.text-sm-right
                            .share
                                button.button.button-plant(v-on:click.stop='toggleShare(true)')
                                    img.button__icon(src='../assets/jobs/icon__share.png')
                                    span.button__text {{data.job_detail.btn_share}}
                                social-sharing(inline-template='', :url='url', v-show='share.show', :title="mail(data.job)")
                                    .socialSharing
                                        .socialSharing__inner
                                            network(network='facebook')
                                                img(src='../assets/jobs/icon__facebook.png', alt='')
                                            network(network='linkedin')
                                                img(src='../assets/jobs/icon__linkedin.png', alt='')
                                            network(network='whatsapp')
                                                img(src='../assets/jobs/icon__whatsapp.png', alt='')
                                            network(network='email')
                                                img(src='../assets/jobs/icon__email.png', alt='')
                    .row
                        .col-12
                            .job
                                .job__main__info
                                    .job__label {{data.job.description_header}}
                                    .job__body(v-html='data.job.description_body')
                                .job__info
                                    .job__label.job__label-gray
                                        | {{data.job.requirements_header}}
                                    .job__body.requirement(v-html='data.job.requirements')
                            .job__remark(v-html='data.job_detail.data_privacy_remarks')
                        .col-12
                            .row.actions
                                .col-6.col-md-6
                                    .action
                                        router-link(to="/jobs", :title='data.job_detail.btn_prev').action__button.action__button-back {{data.job_detail.btn_prev}}
                                .col-6.col-md-6.text-sm-right
                                    .action.action-right
                                        router-link.action__button.action__button-submit(:to='`${jobID}/apply`', :title='data.job_detail.btn_apply')
                                            | {{data.job_detail.btn_apply}}
                WidgetHowToJoin(v-if="data.job_detail.page_bottom", v-bind="data.job_detail.page_bottom")

</template>

<script>
    import LayoutBannerBreadCrumb from "../components/LayoutBannerBreadCrumb.vue";
    import Loading from "../components/Loading.vue";
    import logTraffic from "../utils/logTraffic";
    import PageNotFound from './PageNotFound';
    import WidgetHowToJoin from '../components/WidgetHowToJoin';
    import MetaTags from '../components/MetaTags';

    export default {
        name: "Job",
        props: {
            locale: String,
            jobID: String
        },
        data() {
            return {
                share: {
                    show: false
                }
            }
        },
        mounted() {
            logTraffic(this.$apollo, this.job_id, 'view');
        },
        components: {
            MetaTags,
            WidgetHowToJoin,
            PageNotFound,
            LayoutBannerBreadCrumb,
            Loading,
            SocialSharing
        },
        computed: {
            job_id() {
                return parseInt(this.jobID);
            },
              url() {
                  return window.location.href;
              },
        },
        methods: {
            replaceUrl(html) {
                return html.replace(/<a href=".+"/, `<a href="${this.document}" target="_blank"`);
            },
            toggleShare(show) {
                var self = this;
                if (!show) {
                    setTimeout(function(){
                        self.$set(self.share, 'show', show);
                    }, 500);
                } else {
                    self.$set(self.share, 'show', show);
                }
            },
            mail(job) {
              const category =  job.categories.length ? `(${job.categories[0].name})` : '';
              return `[Job opportunities from PrimeCredit] - ${job.title} ${category}`
            },
        }
    };
</script>

<style lang="sass" scoped>
    @import "../../node_modules/bootstrap/scss/functions"
    @import "../assets/styles/CustomVariables"
    @import "../assets/styles/wysiwyg"
    @import "../assets/styles/common"
    @import "../../node_modules/bootstrap/scss/variables"
    @import "../../node_modules/bootstrap/scss/mixins"
    @import "../../node_modules/bootstrap/scss/grid"
    h2
        font-size: 2.5rem
        color: #76cce1

    a
        cursor: pointer

    .share:hover .button__text
        text-decoration: underline

    .job
        h2
            @include media-breakpoint-down(md)
                font-size: 1.5rem


        &__title
            @extend .text-large
            margin-bottom: 0

        &__label
            @extend .text-medium
            margin-bottom: 1rem
            font-weight: bold

        &__head
            padding-bottom: 2rem
            margin-bottom: 2rem
            border-bottom: 1px solid #ebebeb
            @include media-breakpoint-down(md)
                padding-bottom: 1rem
                margin-bottom: 1rem

        &__body
            &:not(.requirement)
                margin-bottom: 2rem
                @include media-breakpoint-down(md)
                    margin-bottom: 1rem
            @extend .text-normal

        &__main__info
            padding: 0 2rem
            @include media-breakpoint-down(md)
                padding: 0 1rem

        &__info
            padding: 2rem
            margin-bottom: 2rem
            background: #f1fafc
            @include media-breakpoint-down(md)
                padding: 1rem
                margin-bottom: 1rem

        &__remark
            padding: 1rem 2rem
            margin-bottom: 2rem
            background: #ebebeb
            @include media-breakpoint-down(md)
                padding: 1rem
                margin-bottom: 1rem

    .action
        margin-bottom: 5rem
        @include media-breakpoint-down(md)
            margin-bottom: 1rem

        &-right
            @include media-breakpoint-down(md)
                margin-bottom: 2rem

        &__button
            @include media-breakpoint-down(md)
                width: 100%

    .container-job
        @media (min-width: 1600px)
            padding: 0 10rem

    .share
        position: relative
        display: inline-block
        text-align: right

</style>
<style lang="sass">
    .socialSharing
        position: absolute
        top: 100%
        right: 0
        z-index: 10
        width: 140px
        padding-top: 1rem
        text-align: center
        @media (max-width: 570px)
            top: 0
            left: 120%
            width: 100vw
            text-align: left

        &__inner
            display: inline-block
            max-width: 80px
            padding: 1rem 1rem
            background: #ffffff
            box-shadow: 0px 2px 9px 1px rgba(0, 0, 0, 0.3)
            @media (max-width: 570px)
                max-width: none
                padding: .5rem

            & > span
                display: block
                margin-bottom: 1rem
                text-align: center
                cursor: pointer
                @media (max-width: 570px)
                    display: inline
                    margin-right: .5rem

                &:last-child
                    margin-bottom: 0
</style>
